import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "component-title fw-bold small border-bottom pb-2 mb-3" };
const _hoisted_2 = {
    key: 0,
    class: "row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-3"
};
const _hoisted_3 = { class: "col position-relative" };
const _hoisted_4 = {
    key: 0,
    class: "w-100 bg-white d-flex justify-content-center align-items-center",
    style: { "height": "300px" }
};
const _hoisted_5 = {
    key: 1,
    class: "w-100 bg-white py-3",
    style: { "max-height": "300px" }
};
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_8 = { class: "text-center fw-bold" };
const _hoisted_9 = { class: "text-center fw-bold small" };
const _hoisted_10 = { class: "text-center" };
const _hoisted_11 = { class: "col position-relative" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
    class: "w-100 bg-white py-3",
    style: { "max-height": "300px" }
};
const _hoisted_14 = ["src"];
const _hoisted_15 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_16 = { class: "text-center fw-bold" };
const _hoisted_17 = { class: "text-center fw-bold small" };
const _hoisted_18 = { class: "text-center" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
    key: 1,
    class: "d-flex justify-content-center align-items-center flex-column"
};
const _hoisted_21 = { class: "fw-bold text-primary" };
const _hoisted_22 = {
    key: 0,
    id: "contextModal"
};
const _hoisted_23 = { class: "d-block d-md-flex justify-content-between align-items-center mb-3" };
const _hoisted_24 = { class: "fw-bold mb-3 gallery-font-color" };
const _hoisted_25 = ["innerHTML"];
const _hoisted_26 = { class: "d-flex justify-content-center" };
const _hoisted_27 = { class: "ms-4" };
const _hoisted_28 = ["src"];
import { formatters } from '@/Composables/formatters';
import axios from 'axios';
import { onMounted, ref, watch } from 'vue';
import ContextModal from './ContextModal.vue';
import { responseMessages } from '@/Composables/responseMessages';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PackageSelection',
    props: {
        configurationId: String,
        tenantId: String,
        bottle: {
            type: Object,
            required: true
        }
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        let { formatCurrency } = formatters();
        let { showErrorSwal } = responseMessages();
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const searchString = ref('');
        const loading = ref(false);
        const packages = ref([]);
        const detailsPackage = ref(null);
        const modal = ref();
        const selectedPackage = ref(null);
        const standardPackageImage = ref(null);
        onMounted(() => {
            loadDefaultPackageImage();
            loadSavedSelection();
        });
        watch(searchString, () => {
            search();
        });
        function loadDefaultPackageImage() {
            axios.get(route('configurator.imageUrlLoader.standardPackageImage', props.tenantId))
                .then(function (response) {
                standardPackageImage.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
                standardPackageImage.value = null;
            });
        }
        function loadSavedSelection() {
            axios.post(route('configurator.packages.selection.load', props.configurationId), {})
                .then(function (response) {
                if (response.data != null && response.data != '') {
                    selectedPackage.value = response.data;
                    emit('update', selectedPackage.value);
                }
                search();
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function search() {
            axios.post(route('configurator.packages.selection.index'), {
                tenantId: props.tenantId,
                bottleId: props.bottle?.id,
                searchString: searchString.value,
            })
                .then(function (response) {
                packages.value = response.data;
                if (selectedPackage.value) {
                    const selectedPackageIndex = packages.value.findIndex(packageRecord => packageRecord.id === selectedPackage.value?.id);
                    if (selectedPackageIndex === -1) {
                        packages.value.unshift(selectedPackage.value);
                    }
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function showPackageDetails(packageRecord, event) {
            axios.post(route('configurator.packages.selection.details.show', packageRecord.id), {})
                .then(function (response) {
                detailsPackage.value = response.data;
                modal.value.openAt(event.clientX, event.clientY);
            })
                .catch(function (error) {
                console.log(error);
                detailsPackage.value = null;
            });
        }
        function selectPackage(packageRecord) {
            axios.post(route('configurator.packages.selection.store', props.configurationId), {
                packageId: packageRecord?.id,
            })
                .then(function (response) {
                selectedPackage.value = packageRecord;
                emit('update', selectedPackage.value);
            })
                .catch(function (error) {
                console.log(error);
                showErrorSwal(error.response?.data || t('Fehler, bitte versuchen Sie es erneut.'));
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(t)('Verpackungs-Auswahl')), 1),
                (!loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("button", {
                                class: _normalizeClass(["btn bg-light border border-2 rounded-3 p-0 w-100", { 'border border-5 border-success': selectedPackage.value == null }]),
                                style: { "overflow": "hidden" },
                                onClick: _cache[0] || (_cache[0] = ($event) => (selectPackage(null)))
                            }, [
                                (standardPackageImage.value == null || standardPackageImage.value == '')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "100",
                                                fill: "currentColor",
                                                class: "bi bi-box-seam",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z" })
                                            ], -1)
                                        ]))]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("img", {
                                            src: _ctx.route('configurator.imageUrlLoader.standardPackageImage', props.tenantId),
                                            style: { "max-width": "100%" }
                                        }, null, 8, _hoisted_6)
                                    ])),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('Standard-Verpackung')), 1),
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('Verpackung ab Werk')), 1),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatCurrency)(0)), 1)
                                ])
                            ], 2)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packages.value, (packageRecord) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["btn bg-light border border-2 rounded-3 p-0 w-100", { 'border border-5 border-success': selectedPackage.value != null && selectedPackage.value.id == packageRecord.id }]),
                                    style: { "overflow": "hidden" },
                                    onClick: ($event) => (selectPackage(packageRecord))
                                }, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("img", {
                                            src: packageRecord.image,
                                            style: { "max-width": "100%" }
                                        }, null, 8, _hoisted_14)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(packageRecord.name), 1),
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(packageRecord.weight) + " g", 1),
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('ab')) + " " + _toDisplayString(_unref(formatCurrency)(packageRecord.startPrice)), 1)
                                    ])
                                ], 10, _hoisted_12),
                                _createElementVNode("button", {
                                    class: "btn position-absolute end-0 top-0 mt-2 me-3",
                                    onClick: ($event) => (showPackageDetails(packageRecord, $event))
                                }, [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "30",
                                            fill: "currentColor",
                                            class: "bi bi-info-circle-fill text-secondary",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
                                        ], -1)
                                    ]))], 8, _hoisted_19)
                            ]));
                        }), 256))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", {
                            class: "spinner-grow text-primary mb-3",
                            role: "status",
                            style: { "width": "3rem", "height": "3rem" }
                        }, [
                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                        ], -1)),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('Auswahl wird geladen')), 1)
                    ])),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal
                }, {
                    default: _withCtx(() => [
                        (detailsPackage.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h3", _hoisted_24, _toDisplayString(detailsPackage.value.name), 1),
                                        _createElementVNode("div", {
                                            innerHTML: detailsPackage.value.description,
                                            class: "mb-5"
                                        }, null, 8, _hoisted_25)
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("img", {
                                                src: detailsPackage.value.image,
                                                class: "img-fluid rounded",
                                                style: { "max-height": "200px", "max-width": "200px" }
                                            }, null, 8, _hoisted_28)
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
